module.exports = __webpack_public_path__ + "static/media/paginate-left-arrow.8ee390c5.svg";